module.exports = __webpack_public_path__ + "media/images/noticias/bioquimico-d1638e5328594f674e526fcedcad414c.png";